import { render } from "./ChangePassword.vue?vue&type=template&id=4f5997a7"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=4f5997a7&lang=css"
script.render = render

export default script